<script>
  export default {
    name: 'CuontDown',
    data() {
      return {
        day: '',
        hr: '',
        min: '',
        sec: ''
      }
    },
    mounted() {
      this.cuontDown()
    },
    methods: {
      cuontDown() {
        const end = Date.parse(new Date('2022/11/30 23:59:59'))
        const now = Date.parse(new Date())
        const msec = end - now
        if (msec < 0) return
        let day = parseInt(msec / 1000 / 60 / 60 / 24)
        let hr = parseInt((msec / 1000 / 60 / 60) % 24)
        let min = parseInt((msec / 1000 / 60) % 60)
        let sec = parseInt((msec / 1000) % 60)
        this.day = day
        this.hr = hr > 9 ? hr : '0' + hr
        this.min = min > 9 ? min : '0' + min
        this.sec = sec > 9 ? sec : '0' + sec
        let that = this
        if (min >= 0 && sec >= 0) {
          //倒计时结束关闭订单
          if (min == 0 && sec == 0) {
            return
          }
          setTimeout(function() {
            that.cuontDown()
          }, 1000)
        }
      }
    }
  }
</script>
<template>
  <div class="count_down">
    <span>参保倒计时</span>
    <span class="count">{{ day }}</span>
    <span>天</span>
    <span class="count">{{ hr }}</span>
    <span>:</span>
    <span class="count">{{ min }}</span>
    <span>:</span>
    <span class="count">{{ sec }}</span>
  </div>
</template>
<style lang="scss" scoped>
  .count_down {
    width: 100%;
    height: xvw(48);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: xvw(26);
    color: #ffffff;
    span {
      font-size: xvw(35);
    }
    .count {
      font-weight: bolder;
      color: #cb2622;
      background: #ffffff;
      width: xvw(60);
      height: xvw(60);
      background: #ffffff;
      border-radius: xvw(16);
      text-align: center;
      line-height: xvw(60);
      margin: 0 xvw(20);
    }
  }
</style>
